<script setup lang="ts">
const props = defineProps<{
  rating: gen.ProductListingFragment['rating'] | None
}>()

const locale = useLocale()

function reviewLabel(count: number) {
  if (locale.value === 'lt') {
    const mod10 = count % 10
    const mod100 = count % 100

    if (mod10 === 1 && mod100 !== 11) return 'atsiliepimas'
    if (mod10 >= 2 && mod10 <= 9 && !(mod100 >= 12 && mod100 <= 19)) return 'atsiliepimai'
    return 'atsiliepimų'
  }

  return count === 1 ? 'review' : 'reviews'
}
const rating = computed(() => {
  const r = props.rating
  const count = r?.count || 0
  if (!count) return
  const rating = count > 0 ? helpers.fit(+((r?.rating || 0) / 20).toFixed(1), 1, 5) : 0
  return {
    rating,
    count,
    ratingTxt: rating.toFixed(1),
    countTxt: ts(count, reviewLabel(count)),
  }
})
</script>

<template>
  <div v-if="rating?.count || $slots.default" class="_h20 _row _ctry _gap04 _fs09 _wrap _hidden _w100p">
    <template v-if="rating?.count">{{ rating.ratingTxt }}<PostUiStars style="min-width: 75px; color: #fdb913" :count="5" :value="rating.rating" />({{ rating.countTxt }})</template>
    <slot v-else />
  </div>
</template>
